<template>
  <div class="menu-main">
      <div class="menu-left">
          <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" :collapse="isCollapse" @select="AccountMenu">
            <el-menu-item index="/portal/account/MyTrip">
                <img :src="bookingImg" class="menu-img" alt="">
                <span slot="title">{{$t('myBookings')}}</span>
            </el-menu-item>
            <el-submenu index="2">
                <template slot="title">
                    <img src="https://res.roompai.com/static/img/account/my-account-hei.png" class="menu-img" alt="">
                    <span slot="title">{{$t('myAccount')}}</span>
                </template>
                <el-menu-item index="'/portal/account/myAccount?type=user">{{$t('userDetails')}}</el-menu-item>
                <el-menu-item index="'/portal/account/myAccount?type=pay">{{$t('paymentMethods')}}</el-menu-item>
            </el-submenu>
            <el-menu-item index="/account/myCollection">
                <img :src="collectImg" class="menu-img" alt="">
                <span slot="title">{{$t('myFavorite')}}</span>
            </el-menu-item>
            <el-menu-item index="/account/myCoupon">
              <img :src="couponImg" class="menu-img" alt="">
              <span slot="title">{{$t('coupon')}}</span>
          </el-menu-item>
          </el-menu>
      </div>
  </div>
</template>

<script>
export default {
  name: 'publicAccountMenu',
  data () {
    return {
      isCollapse: false,
      bookingImg: 'https://res.roompai.com/static/img/account/my-trip-an.png',
      myAccountImg: 'https://res.roompai.com/static/img/account/my-account-hei.png',
      collectImg: 'https://res.roompai.com/static/img/account/my-collection-an.png',
      couponImg: '/static/img/account/my-coupon-an.png',
      defaultActive: ''
    }
  },
  mounted: function () {
    var path = this.$route.path
    if (path.indexOf('MyTrip') !== -1 || path.indexOf('tripDetail') !== -1) {
      this.bookingImg = 'https://res.roompai.com/static/img/account/my-trip-lan.png'
      // this.myAccountImg = 'https://res.roompai.com/static/img/account/my-account-an.png'
      this.collectImg = 'https://res.roompai.com/static/img/account/my-collection-an.png'
      this.couponImg = '/static/img/account/my-coupon-an.png'
      this.defaultActive = '/portal/account/MyTrip'
    } else if (path.indexOf('myAccount') !== -1) {
      this.bookingImg = 'https://res.roompai.com/static/img/account/my-trip-an.png'
      // this.myAccountImg = 'https://res.roompai.com/static/img/account/my-account-lan.png'
      this.collectImg = 'https://res.roompai.com/static/img/account/my-collection-an.png'
      this.couponImg = '/static/img/account/my-coupon-an.png'
      var type = this.$route.query.type
      if (type.indexOf('user') !== -1) {
        this.defaultActive = '/portal/account/myAccount?type=user'
      } else {
        this.defaultActive = '/portal/account/myAccount?type=pay'
      }
    } else if (path.indexOf('myCollection') !== -1) {
      this.bookingImg = 'https://res.roompai.com/static/img/account/my-trip-an.png'
      // this.myAccountImg = 'https://res.roompai.com/static/img/account/my-account-an.png'
      this.collectImg = 'https://res.roompai.com/static/img/account/my-collection-lan.png'
      this.couponImg = '/static/img/account/my-coupon-an.png'
      this.defaultActive = '/booking/account/myCollection'
    } else if (path.indexOf('myCoupon') !== -1) {
      this.bookingImg = 'https://res.roompai.com/static/img/account/my-trip-an.png'
      this.collectImg = 'https://res.roompai.com/static/img/account/my-collection-an.png'
      this.couponImg = '/static/img/account/my-coupon-lan.png'
      this.defaultActive = '/account/myCoupon'
    }
  },
  methods: {
    AccountMenu (val) {
      if (val.indexOf('user') !== -1) {
        this.$emit('getSonSelect', 'user')
      } else if (val.indexOf('pay') !== -1) {
        this.$emit('getSonSelect', 'pay')
      }
      this.$router.push(val)
    }
  }
}
</script>

<style scoped>
/* 侧栏 */
.el-menu-vertical-demo:not(.el-menu--collapse) {width: 80%;float: right;margin-top: 25px;}
.el-menu-vertical-demo .el-menu-item,.el-submenu__title span{font-family: PingFangSCRegular, 'PingFang SC Medium', 'PingFang SC', sans-serif;font-weight: 500;font-style: normal;font-size: 16px;color: #4F4C4C;text-align: left;}
.menu-img{width:17px;height:17px;padding-right:10px;}
.el-menu--inline .el-menu-item{font-size:14px; font-weight: 500;padding-left: 52px !important;}
.el-menu {border-right:none;}
.menu-left /deep/ .el-submenu__icon-arrow{font-size: 20px;}
.menu-left /deep/ .el-submenu{margin: 5px 0px;}
.menu-left /deep/ .el-menu-item{margin-top: 5px;}
a{ text-decoration: none;}
.el-menu /deep/ .el-menu-item:hover{
    outline: 0 !important;
    color: #4F4C4C !important;
    background: rgba(252, 210, 5, 0.09803921568627451) !important;
}
.el-menu /deep/ .el-menu-item.is-active {
    color: rgb(83, 146, 249) !important;
    background: rgba(252, 210, 5, 0.09803921568627451) !important;
}
.el-submenu /deep/ .el-submenu__title:hover {
  color: #4F4C4C !important;
  background: rgba(252, 210, 5, 0.09803921568627451) !important;
}
@media only screen and (min-width:1500px){
  .menu-left{width: 100%;height: 100%;position:none;box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451); -webkit-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451)}
}
</style>



// WEBPACK FOOTER //
// src/components/public/publicAccountMenu.vue